<template>
  <div class="container mx-auto flex justify-center flex-wrap flex-col px-4 sm:px-10">
    <slot />
  </div>
</template>
